import { defineMessages } from 'react-intl';

type MessageKeys = 'noImprovementMessage' | 'successIconLabel';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		noImprovementMessage: {
			id: 'fabric.editor.ai.screens.noImprovement.noImprovementMessage',
			defaultMessage: `No improvements, nice work.`,
			description: 'Message to display when no improvements are available for the prompt',
		},
		successIconLabel: {
			id: 'fabric.editor.ai.screens.noImprovement.successIconLabel',
			defaultMessage: 'Success',
			description: 'Aria label for the success icon on the "No Improvement" screen',
		},
	});

export default message;
